<script setup lang="ts">
import BreadCrumb from "@/components/BreadCrumb.vue";
import ShadowBox from "@/components/ShadowBox.vue";
import StyledTabNavbar from "@/components/StyledTabNavbar.vue";
import { TabGroup, TabPanel, TabPanels } from "@headlessui/vue";
import ActiveCards from "../components/ActiveCards.vue";
import CardForm from "../components/CardForm.vue";
import DisabledCards from "../components/DisabledCards.vue";
const tabs = ["Activas", "Desactivadas"];

const pages = [
  {
    name: "Tarjetas enlace",
    to: { name: "card.index" },
    current: false,
  },
];
</script>

<template>
  <BreadCrumb :pages="pages"></BreadCrumb>
  <div class="w-full xl:px-8 py-4 xl:mx-auto px-4 gap-5">
    <div
      class="mt-5 flex md:flex-row flex-col-reverse items-center justify-center mx-auto gap-10"
    >
      <!-- <ActiveCards class="xl:w-1/3 md:w-2/5" /> -->
      <ShadowBox class="xl:w-1/3 md:w-2/5 gap-5 py-0">
        <TabGroup as="div">
          <header class="flex justify-between">
            <h1 class="mb-3 px-2 font-extrabold text-2xl uppercase">
              Tarjetas
            </h1>

            <StyledTabNavbar
              :tabs="tabs"
              :tab-class="'after:bg-red-500'"
              :invidivual-tab-class="{
                2: {
                  base: 'hover:after:bg-red-500',
                  selected: 'after:!bg-red-500',
                },
              }"
            />
          </header>

          <TabPanels as="div">
            <TabPanel>
              <EnterTransitionWrapper>
                <ActiveCards />
              </EnterTransitionWrapper>
            </TabPanel>

            <TabPanel>
              <EnterTransitionWrapper>
                <DisabledCards />
              </EnterTransitionWrapper>
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </ShadowBox>
      <CardForm class="xl:w-2/3 md:w-1/2" />
    </div>
  </div>
</template>
<style scoped>
h2 {
  font-weight: 600;
}
</style>
